<template>
    <form @submit.prevent="submit">
        <div>
            <div class="card">
                <h2 class="card-header">
                    Preparer</h2>
                <div class="card-body">
                    <div class="form-row">
                        <div class="col-lg-3">
                            <div class="form-group">
                                <strong>Health Plan ID: {{hccisId}}</strong>
                            </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="form-group">
                            <strong>{{company}}</strong>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="form-group">
                            <strong>Calendar Year {{contact.reportYear}}</strong>
                          </div>
                        </div>
                    </div>
                    <p></p>
                    <div class="form-row">
                        <div class="col-md-8" style="padding-bottom: 10px;">
                            <div class="form-group ">
                                <label for="selectypeContact" style="...">Select an action for this contact:</label>
                                <select v-model="selectedEdit" v-on:change="changeContact(selectedEdit)"
                                        size="4"
                                        style="width: 500px; border: 2px solid; padding: 5px;"
                                        id="selectypeContact">
                                    <option value="1">No changes</option>
                                    <option v-if="(contact.prepareEmail !== '' || contact.prepareNamef !== '' || contact.prepareNamel !== '')"
                                            value="2">Edit {{(contact.prepareNamef !== '' || contact.prepareNamel !==
                                        '') ? contact.prepareNamef + " " + contact.prepareNamel : "new contact"}}
                                    </option> <!-- edit contact in contact edit table -->
                                    <option value="3">Search for a different preparer</option>
                                    <!-- if selected, edit linkage? and all contacts -->
                                    <option value="4">Add a new preparer</option>
                                    <!-- add new contact to contact edit table, edit linkage and all contacts -->
                                </select>
                                <p/>
                            </div>
                        </div>
                    </div>
                    <div class="form-row" v-if="viewNoChangesText"><p>If all required fields are filled out correctly,
                        you may scroll down and proceed.</p></div>
                    <!-- <b-button v-if="'Y' === 'Y'" v-b-modal.modal-search-contacts variant="primary" style="margin-bottom:20px;" @click="contact.type = 'preparer'">Add a Contact</b-button> -->
                    <b-modal id="modal-search-contacts" size="xl" hide-header hide-footer scrollable
                             @hide="resetSelection">
                        <h2>Search Contacts</h2>
                        <hr/>
                        <form ref="form" @submit.prevent="save">
                            <div v-show="'preparer'=== 'preparer'">
                                <b-row>
                                    <div class="col-lg-12">
                                        <EmailSearch :original-contact="contact" @enable="enable" v-model="contact"
                                                     :v="$v.contact"/>
                                    </div>
                                </b-row>
                            </div>


                            <b-row style="padding-top: 10px;">
                                <b-col>
                                    <b-button @click="close" style="margin-right:15px;">Close</b-button>
                                </b-col>
                            </b-row>
                        </form>
                    </b-modal>

                    <div class="form-row">
                        <div class="col-lg-2">
                            <div class="form-group ">
                                <label for="salutation">Salutation: </label>
                                <input :disabled="keepDisabled" type="text" id="salutation" required maxlength="25"
                                       class="form-control" v-model.trim="$v.contact.salutation.$model"
                                       :class="{'is-invalid': $v.contact.salutation.$error}">
                                <span v-if="!$v.contact.salutation.invalid" class="invalid-feedback">Salutation is invalid</span>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group ">
                                <!--
                                <input :disabled="keepDisabled" type="text" id="prepareNamef" required
                                       class="form-control" v-model.trim="$v.contact.prepareNamef.$model"
                                       :class="{'is-invalid': $v.contact.prepareNamef.$error}">
                                <span v-if="!$v.contact.prepareNamef.invalid" class="invalid-feedback">First name is invalid</span>
                                -->
                                <label for="prepareNamef">First Name *: </label>
                                <b-form-input :disabled="keepDisabled" id="prepareNamef" required
                                              type="text" class="form-control"
                                              v-model.trim="$v.contact.prepareNamef.$model"
                                              :class="{'is-invalid': validationStatus($v.contact.prepareNamef)}"
                                              aria-label="Contact first name">
                                </b-form-input>
                                <div v-if="!$v.contact.prepareNamef.required" class="invalid-feedback">
                                    First name is required
                                </div>
                                <div v-if="!$v.contact.prepareNamef.minLength"
                                     class="invalid-feedback">Text needs to be entered
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group ">
                                <!--
                                <input :disabled="keepDisabled" type="text" id="prepareNamel" required
                                       class="form-control" v-model.trim="$v.contact.prepareNamel.$model"
                                       :class="{'is-invalid': $v.contact.prepareNamel.$error}">
                                <span v-if="!$v.contact.prepareNamel.invalid" class="invalid-feedback">Last name is invalid</span>
                                -->
                                <label for="prepareNamel">Last Name *: </label>
                                <b-form-input :disabled="keepDisabled" id="prepareNamel" required
                                              type="text" class="form-control"
                                              v-model.trim="$v.contact.prepareNamel.$model"
                                              :class="{'is-invalid': validationStatus($v.contact.prepareNamel)}"
                                              aria-label="Contact last name">
                                </b-form-input>
                                <div v-if="!$v.contact.prepareNamel.required" class="invalid-feedback">
                                    Last name is required
                                </div>
                                <div v-if="!$v.contact.prepareNamel.minLength"
                                     class="invalid-feedback">Text needs to be entered
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-12 col-md-12">
                            <div class="form-group ">
                                <label for="title">Preparer's Title: </label>
                                <input :disabled="keepDisabled" type="text" id="title"
                                       required class="form-control" maxlength="50"
                                       v-model.trim="$v.contact.title.$model"
                                       :class="{'is-invalid': $v.contact.title.$error} ">
                                <span v-if="!$v.contact.title.invalid" class="invalid-feedback">Title is invalid</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="prepareEmail">Preparer's Email *: </label>
                                <b-form-input :disabled="keepDisabled" id="prepareEmail"
                                              type="email" class="form-control"
                                              v-model.trim="$v.contact.prepareEmail.$model"
                                              :class="{'is-invalid': validationStatus($v.contact.prepareEmail)}"
                                              aria-label="Contact email">
                                </b-form-input>
                                <div v-if="!$v.contact.prepareEmail.required" class="invalid-feedback">
                                    Preparer email is required
                                </div>
                                <div v-if="!$v.contact.prepareEmail.email" class="invalid-feedback">
                                    Preparer email must be a valid email address
                                </div>
                                <div v-if="!$v.contact.prepareEmail.minLength"
                                     class="invalid-feedback">Text needs to be entered
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-sm-12 col-md-12">
                            <div class="form-group ">
                                <label for="prepareorgName">Organization Name:</label>
                                <input :disabled="keepDisabled" type="text" id="prepareorgName" required maxlength="100"
                                       class="form-control" v-model.trim="$v.contact.prepareorgName.$model"
                                       :class="{'is-invalid': $v.contact.prepareorgName.$error}">
                                <span v-if="!$v.contact.prepareorgName.invalid" class="invalid-feedback">Organization name is invalid</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="preparePhone">Phone:</label>
                                <input :disabled="keepDisabled" type="tel"  v-mask="'###-###-####'"  id="preparePhone"
                                       required class="form-control" v-model.trim="$v.contact.preparePhone.$model"
                                       :class="{'is-invalid': $v.contact.preparePhone.$error}">
                                <span v-if="!$v.contact.preparePhone.error"
                                      class="invalid-feedback">Phone is invalid</span>
                                <div v-if="!$v.contact.preparePhone.required" class="invalid-feedback">
                                    First digit of area code and prefix must be 2 or greater
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="phoneExt">Phone Ext:</label>
                                <input :disabled="keepDisabled" type="text" id="phoneExt" class="form-control"
                                       v-model.trim="$v.contact.phoneExt.$model"
                                       :class="{'is-invalid': $v.contact.phoneExt.$error}"
                                       v-mask="'###########'">
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="prepareFax">Fax:</label>
                                <input :disabled="keepDisabled" type="tel" v-mask="'###-###-####'" id="prepareFax"
                                       class="form-control" v-model.trim="$v.contact.prepareFax.$model"
                                       :class="{'is-invalid': $v.contact.prepareFax.$error}">
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="prepareAddress">Address Line 1 (example: 123 Main Street North, or PO Box
                                    153):</label>
                                <input :disabled="keepDisabled" type="text" id="prepareAddress" required
                                       class="form-control" v-model.trim="$v.contact.prepareAddress.$model"
                                       :class="{'is-invalid': $v.contact.prepareAddress.$error}">
                                <span v-if="!$v.contact.prepareAddress.invalid" class="invalid-feedback">Address Line 1 is invalid</span>
                            </div>

                            <div class="form-group ">
                                <label for="streetAddress2">Address Line 2 (example: Suite B):</label>
                                <input :disabled="keepDisabled" type="text" id="streetAddress2" required
                                       class="form-control" v-model.trim="$v.contact.streetAddress2.$model"
                                       :class="{'is-invalid': $v.contact.streetAddress2.$error}">
                                <span v-if="!$v.contact.streetAddress2.invalid" class="invalid-feedback">Address Line 2 is invalid</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="prepareCity">City:</label>
                                <input :disabled="keepDisabled" type="text" id="prepareCity" required v-uppercase
                                       class="form-control" v-model.trim="$v.contact.prepareCity.$model"
                                       v-on:change="saintToSt(1, 1)"
                                       :class="{'is-invalid': $v.contact.prepareCity.$error}">
                                <span v-if="!$v.contact.prepareCity.invalid"
                                      class="invalid-feedback">City is invalid</span>
                            </div>
                        </div>
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="prepareCounty">County:</label>
                                <input :disabled="keepDisabled" type="text" id="prepareCounty" required v-uppercase
                                       class="form-control" v-model.trim="$v.contact.prepareCounty.$model"
                                       v-on:change="saintToSt(2, 1)"
                                       :class="{'is-invalid': $v.contact.prepareCounty.$error}">
                                <span v-if="!$v.contact.prepareCounty.invalid" class="invalid-feedback">County is invalid</span>
                            </div>

                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="prepareState">State/Province: </label>
                                <v-select
                                    :disabled="keepDisabled"
                                    id="prepareState"
                                    v-model.trim="$v.contact.prepareState.$model"
                                    :options="stateProvince"
                                    :reduce="text => text.value"
                                    :items="stateProvince.value"
                                    label="text"
                                    type="select"
                                    placeholder="Select a state or province"
                                    :class="{'is-invalid': validationStatus($v.contact.prepareState)}"
                                ></v-select>
                                <span v-if="!$v.contact.prepareState.required"
                                      class="invalid-feedback">State is required</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group " v-if="!selectedCountryCan($v.contact.prepareState.$model,1)">
                                <label for="prepareZip5">U.S. ZIP Code or Canadian Postal Code:</label>
                                <input :disabled="keepDisabled" type="text" id="prepareZip5" v-mask="'#####'"
                                       required
                                       class="form-control" v-model.trim="$v.contact.prepareZip5.$model"
                                       :class="{'is-invalid': $v.contact.prepareZip5.$error}">
                                <span v-if="!$v.contact.prepareZip5.invalid"
                                      class="invalid-feedback">Zip is invalid</span>
                            </div>
                        </div>

                        <div class="col-sm-5 col-md-6">
                            <div class="form-group " v-if="!selectedCountryCan($v.contact.prepareState.$model,1)">
                                <label for="prepareZip4">U.S. ZIP Code Extension:</label>
                                <input :disabled="isDisabledC(contact.prepareZip5)" type="text" id="prepareZip4"
                                       v-mask="'####'" required
                                       class="form-control" v-model.trim="$v.contact.prepareZip4.$model"
                                       :class="{'is-invalid': $v.contact.prepareZip4.$error}">
                                <span v-if="!$v.contact.prepareZip4.invalid"
                                      class="invalid-feedback">Zip extension is invalid</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group " v-if="selectedCountryCan($v.contact.prepareState.$model,1)">
                                <label for="canZipContact">U.S. ZIP Code or Canadian Postal Code:</label>
                                <input :disabled="keepDisabled" type="text" id="canZipContact" v-mask="'A#A #A#'"
                                       required class="form-control" v-model.trim="$v.contact.canZipContact.$model"
                                       :class="{'is-invalid': $v.contact.canZipContact.$error}">
                                <span v-if="!$v.contact.canZipContact.invalid"
                                      class="invalid-feedback">Postal code is invalid</span>
                            </div>
                        </div>
                    </div>


                    <div class="form-row">
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="prepareSupNamef">Supervisor's First Name:</label>
                                <input :disabled="keepDisabled" type="text" id="prepareSupNamef" required maxlength="50"
                                       class="form-control" v-model.trim="$v.contact.prepareSupNamef.$model"
                                       :class="{'is-invalid': $v.contact.prepareSupNamef.$error}">
                                <span v-if="!$v.contact.prepareSupNamef.invalid" class="invalid-feedback">Supervisor first name is invalid</span>
                            </div>
                        </div>

                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="prepareSupNamel">Supervisor's Last Name:</label>
                                <input :disabled="keepDisabled" type="text" id="prepareSupNamel" required maxlength="50"
                                       class="form-control" v-model.trim="$v.contact.prepareSupNamel.$model"
                                       :class="{'is-invalid': $v.contact.prepareSupNamel.$error}">
                                <span v-if="!$v.contact.prepareSupNamel.invalid" class="invalid-feedback">Supervisor last name is invalid</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-sm-12 col-md-12">
                            <div class="form-group ">
                                <label for="prepareSupTitle">Supervisor's Title:</label>
                                <input :disabled="keepDisabled" type="text" id="prepareSupTitle" required maxlength="50"
                                       class="form-control" v-model.trim="$v.contact.prepareSupTitle.$model"
                                       :class="{'is-invalid': $v.contact.prepareSupTitle.$error}">
                                <span v-if="!$v.contact.prepareSupTitle.invalid" class="invalid-feedback">Supervisor title is invalid</span>
                            </div>
                        </div>
                        <div class="col-sm-5 col-md-6">
                            <div class="form-group ">
                                <label for="prepareSupEmail">Supervisor's Email:</label>
                                <input :disabled="keepDisabled" type="email" id="prepareSupEmail" required max="50"
                                       class="form-control" v-model.trim="$v.contact.prepareSupEmail.$model"
                                       :class="{'is-invalid': $v.contact.prepareSupEmail.$error}">
                                <div v-if="!$v.contact.prepareSupEmail.required" class="invalid-feedback">
                                    Supervisor email is required
                                </div>
                                <div v-if="!$v.contact.prepareSupEmail.email" class="invalid-feedback">
                                    Supervisor email must be a valid email address
                                </div>
                                <div v-if="!$v.contact.prepareSupEmail.minLength" class="invalid-feedback">
                                    Text needs to be entered
                                </div>
                            </div>
                            <div class="form-group ">

                                <label for="prepareSupPhone">Supervisor's Phone:</label>
                                <input :disabled="keepDisabled" type="tel" v-mask="'###-###-####'"
                                       id="prepareSupPhone" required class="form-control"
                                       v-model.trim="$v.contact.prepareSupPhone.$model"
                                       :class="{'is-invalid': $v.contact.prepareSupPhone.$error}">
                                <span v-if="!$v.contact.prepareSupPhone.invalid" class="invalid-feedback">Supervisor phone is invalid</span>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="form-row"  style="padding-bottom: 10px;">
                        <div class="col-md-4"> <b-button variant="primary" to="plan">Previous</b-button> </div>
                        <div class="col-md-4"> <b-button aria-colspan="2" variant="primary" v-on:click="addContact">Add a courtesy contact (optional)</b-button> </div>
                        <div class="col-md-4"> <b-button aria-colspan="2" variant="primary" v-on:click="changeContact(selectedEdit)">Proceed</b-button> </div>
                    </div> -->
                </div>
            </div>
            <br>
            <button type="button" @click="toggleShowCC1()" class="btn btn-outline-primary col-lg-3 col-sm-6">
                {{showCC1 ? 'Remove Courtesy Contact 1 (Optional)' : 'Add Courtesy Contact 1 (Optional)'}}
            </button>
            <div class="sr-only" aria-live="assertive" aria-atomic="true">
                {{courtesyContactMessage}}
            </div>
            <br><br>
            <div v-show="showCC1" class="form-group" :class="{ 'form-group--error': $v.courtesyContact.$error }">
                <div class="card mb-3" header-bg-variant="primary" header-text-variant="white">
                    <h2 class="card-header">Courtesy Contact 1 (optional)</h2>
                    <div class="card-body">
                        <p>Review courtesy contact.</p>

                        <div class="form-row">
                            <div class="col-md-8" style="padding-bottom: 10px;">
                                <div class="form-group ">
                                    <label for="selectypeCourtesy1" style="color: #0062cc">Select an action for this contact:&nbsp; </label>
                                    <select v-model="selectedEditCC1" v-on:change="changeCC1(selectedEditCC1)"
                                            size="4"
                                            style="width: 500px; border: 2px solid; padding: 5px;"
                                            id="selectypeCourtesy1">
                                        <option value="1">No changes</option>
                                        <option v-if="(courtesyContact.prepareEmail !== '' || courtesyContact.prepareNamef !== '' || courtesyContact.prepareNamel !== '')"
                                                value="2">Edit {{(courtesyContact.prepareNamef !== '' ||
                                            courtesyContact.prepareNamel !== '') ? courtesyContact.prepareNamef + " " +
                                            courtesyContact.prepareNamel : "new contact"}}
                                        </option>
                                        <option value="3">Search for a different courtesy contact</option>
                                        <option value="4">Add a new courtesy contact</option>
                                    </select>
                                    <p/>
                                </div>
                            </div>
                        </div>
                        <b-modal id="modal-search-courtesy-contact" size="xl" hide-header hide-footer scrollable
                                 @hide="resetSelection">
                            <h2>Search Contacts</h2>
                            <hr/>
                            <form ref="form" @submit.prevent="save">
                                <div v-show="'preparer'=== 'preparer'">
                                    <b-row>
                                        <b-col cols="12">
                                            <EmailSearch :original-contact="courtesyContact" @enable="enableCC1"
                                                         v-model="courtesyContact"
                                                         :v="$v.courtesyContact"/>
                                        </b-col>
                                    </b-row>
                                </div>

                                <b-row style="padding-top: 10px;">
                                    <b-col>
                                        <b-button @click="close" style="margin-right:15px;">Close</b-button>
                                    </b-col>
                                </b-row>
                            </form>
                        </b-modal>

                        <div class="form-row">

                            <div class="col-xl-4 col-lg-4 col-md-4">
                                <div class="form-group">
                                    <label for="courtesyContact-salutation">Courtesy Contact Salutation:</label>
                                    <div class="w-50">
                                        <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-salutation"
                                                      type="text" class="form-control"
                                                      v-model.trim="$v.courtesyContact.salutation.$model"
                                                      :class="{'is-invalid': validationStatus($v.courtesyContact.salutation)}"
                                                      aria-label="Courtesy Contact Salutation">
                                        </b-form-input>
                                    </div>
                                    <div v-if="!$v.courtesyContact.salutation.required" class="invalid-feedback">
                                        Courtesy contact salutation is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.salutation.minLength" class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4">
                                <div class="form-group">
                                    <label for="courtesyContact-prepareNamef">Courtesy Contact First Name:</label>
                                    <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareNamef"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact.prepareNamef.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact.prepareNamef)}"
                                                  aria-label="Courtesy contact first name">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact.prepareNamef.required" class="invalid-feedback">
                                        Courtesy contact first name is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.prepareNamef.minLength" class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4">
                                <div class="form-group">
                                    <label for="courtesyContact-prepareNamel">Courtesy Contact Last Name:</label>
                                    <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareNamel"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact.prepareNamel.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact.prepareNamel)}"
                                                  aria-label="Courtesy contact last name">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact.prepareNamel.required" class="invalid-feedback">
                                        Courtesy contact last name is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.prepareNamel.minLength" class="invalid-feedback">
                                        Text
                                        needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">

                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label for="courtesyContact-title">Courtesy Contact Title:</label>
                                    <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-title" type="text"
                                                  class="form-control"
                                                  v-model.trim="$v.courtesyContact.title.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact.title)}"
                                                  aria-label="Courtesy contact title">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact.title.required" class="invalid-feedback">Courtesy
                                        contact title is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.title.minLength" class="invalid-feedback">Text
                                        needs to be entered
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="form-row">

                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact-prepareEmail">Courtesy Contact Email:</label>
                                    <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareEmail"
                                                  type="email" class="form-control" max="50"
                                                  v-model.trim="$v.courtesyContact.prepareEmail.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact.prepareEmail)}"
                                                  aria-label="Courtesy contact email">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact.prepareEmail.required" class="invalid-feedback">
                                        Courtesy contact email is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.prepareEmail.email" class="invalid-feedback">
                                        Courtesy contact email must be a valid email address
                                    </div>
                                    <div v-if="!$v.courtesyContact.prepareEmail.minLength" class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label for="courtesyContact-prepareorgName">Courtesy Contact Organization Name:</label>
                                    <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareorgName"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact.prepareorgName.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact.prepareorgName)}"
                                                  aria-label="Courtesy contact organization name">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact.prepareorgName.required"
                                         class="invalid-feedback">Courtesy Contact Organization Name is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.prepareorgName.minLength"
                                         class="invalid-feedback">Text needs to be entered
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact-preparePhone">Courtesy Contact Phone Number:</label>
                                    <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-preparePhone"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact.preparePhone.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact.preparePhone)}"
                                                  aria-label="Courtesy contact phone number"
                                                  v-mask="'###-###-####'">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact.preparePhone.required" class="invalid-feedback">
                                        Courtesy contact phone number is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.preparePhone.minLength" class="invalid-feedback">
                                        Text
                                        needs to be entered
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact-phoneExt">Courtesy Contact Phone Extension:</label>
                                    <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-phoneExt"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact.phoneExt.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact.phoneExt)}"
                                                  aria-label="Courtesy contact phone extension"
                                                  v-mask="'###########'">
                                    </b-form-input>

                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact-prepareFax">Courtesy Contact Fax Number:</label>
                                    <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareFax"
                                                  type="text" class="form-control"
                                                  aria-label="Courtesy contact fax number"
                                                  v-model.trim="$v.courtesyContact.prepareFax.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact.prepareFax)}"
                                                  v-mask="'###-###-####'">
                                    </b-form-input>
                                </div>
                            </div>

                        </div>

                        <div class="form-row">

                            <div class="col-xl-8 col-lg-8 col-md-8">
                                <div class="form-group">
                                    <label for="courtesyContact-prepareAddress">Courtesy Contact Address Line 1
                                        (example: 123 Main Street North, or PO Box 153):</label>
                                    <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareAddress"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact.prepareAddress.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact.prepareAddress)}"
                                                  aria-label="Courtesy Contact Address Line 1">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact.prepareAddress.required"
                                         class="invalid-feedback">Courtesy contact address line 1 is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.prepareAddress.minLength"
                                         class="invalid-feedback">Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-8 col-lg-8 col-md-8">
                                <div class="form-group">
                                    <label for="courtesyContact-streetAddress2">Courtesy Contact Address Line 2
                                        (example: Suite B):</label>
                                    <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-streetAddress2"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact.streetAddress2.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact.streetAddress2)}"
                                                  aria-label="Courtesy Contact Address Line 2">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact.streetAddress2.required"
                                         class="invalid-feedback">Courtesy contact address line 2 is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.streetAddress2.minLength"
                                         class="invalid-feedback">Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact-prepareCity">Courtesy Contact City:</label>
                                    <input :disabled="keepDisabledCC1" id="courtesyContact-prepareCity"
                                           type="text" class="form-control" v-uppercase
                                           v-model.trim="$v.courtesyContact.prepareCity.$model"
                                           v-on:change="saintToSt(1, 2)"
                                           :class="{'is-invalid': validationStatus($v.courtesyContact.prepareCity)}"
                                           aria-label="Courtesy contact city" />
                                    <div v-if="!$v.courtesyContact.prepareCity.required" class="invalid-feedback">
                                        Courtesy contact city is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.prepareCity.minLength" class="invalid-feedback">
                                        Text
                                        needs to be entered
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact-prepareCounty">Courtesy Contact County:</label>
                                    <input :disabled="keepDisabledCC1" id="courtesyContact-prepareCounty"
                                           type="text" class="form-control" v-uppercase
                                           v-model.trim="$v.courtesyContact.prepareCounty.$model"
                                           v-on:change="saintToSt(2, 2)"
                                           :class="{'is-invalid': validationStatus($v.courtesyContact.prepareCounty)}"
                                           aria-label="Courtesy contact county" />
                                    <div v-if="!$v.courtesyContact.prepareCounty.required" class="invalid-feedback">
                                        Courtesy contact county is required
                                    </div>
                                    <div v-if="!$v.courtesyContact.prepareCounty.minLength"
                                         class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact-prepareState">Courtesy Contact
                                        State/Province: </label>
                                    <v-select
                                        :disabled="keepDisabledCC1"
                                        id="courtesyContact-prepareState"
                                        v-model.trim="$v.courtesyContact.prepareState.$model"
                                        :options="stateProvince"
                                        :reduce="text => text.value"
                                        :items="stateProvince.value"
                                        label="text"
                                        type="select"
                                        placeholder="Select a state or province"
                                        :class="{'is-invalid': validationStatus($v.courtesyContact.prepareState)}"
                                    ></v-select>
                                    <span v-if="!$v.courtesyContact.prepareState.required"
                                          class="invalid-feedback">State/Provice is required</span>
                                </div>
                            </div>

                        </div>

                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group "
                                     v-if="!selectedCountryCan($v.courtesyContact.prepareState.$model,2)">
                                    <label for="courtesyContact-prepareZip5">Courtesy Contact U.S. ZIP Code or Canadian Postal Code:</label>

                                    <input :disabled="keepDisabledCC1" type="text" id="courtesyContact-prepareZip5"
                                           v-mask="'#####'" required width="100%"
                                           class="form-control" v-model.trim="$v.courtesyContact.prepareZip5.$model"
                                           :class="{'is-invalid': $v.courtesyContact.prepareZip5.$error}"/>
                                    <div v-if="!$v.courtesyContact.prepareZip5.minLength" class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group "
                                     v-if="!selectedCountryCan($v.courtesyContact.prepareState.$model,2)">

                                    <label for="courtesyContact-prepareZip4">Courtesy Contact U.S. ZIP Code
                                        Extension:</label>
                                    <input :disabled="isDisabledCC1(courtesyContact.prepareZip5)"
                                           id="courtesyContact-prepareZip4"
                                           type="text" v-mask="'####'" class="form-control"
                                           v-model.trim="$v.courtesyContact.prepareZip4.$model"
                                           :class="{'is-invalid': validationStatus($v.courtesyContact.prepareZip4)}"
                                           aria-label="Courtesy contact zip code ext"/>
                                    <div v-if="!$v.courtesyContact.prepareZip4.minLength" class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group "
                                     v-if="selectedCountryCan($v.courtesyContact.prepareState.$model,2)">
                                    <label for="courtesyContact-canZipContact">Courtesy Contact U.S. ZIP Code or Canadian Postal Code:</label>
                                    <input :disabled="keepDisabledCC1" id="courtesyContact-canZipContact"
                                           type="text" v-mask="'A#A #A#'"
                                           class="form-control"
                                           v-model.trim="$v.courtesyContact.canZipContact.$model"
                                           :class="{'is-invalid': validationStatus($v.courtesyContact.canZipContact)}"
                                           aria-label="Courtesy contact postal code"/>
                                    <div v-if="!$v.courtesyContact.canZipContact.minLength"
                                         class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <button type="button" @click="toggleShowCC2()" class="btn btn-outline-primary col-lg-3 col-sm-6">
                    {{showCC2 ? 'Remove Courtesy Contact 2 (Optional)' : 'Add Courtesy Contact 2 (Optional)'}}
                </button>
                <div class="sr-only" aria-live="assertive" aria-atomic="true">
                    {{courtesyContact2Message}}
                </div>
            </div>
            <br>
            <div v-show="showCC2" class="form-group" :class="{ 'form-group--error': $v.courtesyContact2.$error }">
                <div class="card mb-3" header-bg-variant="primary" header-text-variant="white">
                    <h2 class="card-header">Courtesy Contact 2 (optional)</h2>
                    <div class="card-body">
                        <p>Review courtesy contact.</p>
                        <div class="form-row">
                            <div class="col-md-8" style="padding-bottom: 10px;">
                                <div class="form-group">
                                    <label for="selectypeCourtesy2" style="color: #0062cc">Select an action for this contact:&nbsp; </label>
                                    <select v-model="selectedEditCC2" v-on:change="changeCC2(selectedEditCC2)"
                                            size="4"
                                            style="width: 500px; border: 2px solid; padding: 5px;"
                                            id="selectypeCourtesy2">
                                        <option value="1">No changes</option>
                                        <option value="2"
                                                v-if="(courtesyContact2.prepareEmail !== '' || courtesyContact2.prepareNamef !== '' || courtesyContact2.prepareNamel !== '')">
                                            Edit {{(courtesyContact2.prepareNamef !== '' ||
                                            courtesyContact2.prepareNamel !== '') ? courtesyContact2.prepareNamef +
                                            " " + courtesyContact2.prepareNamel : "new contact"}}
                                        </option>
                                        <option value="3">Search for a different courtesy contact</option>
                                        <option value="4">Add a new courtesy contact</option>
                                    </select>
                                    <p/>
                                </div>
                            </div>
                        </div>
                        <b-modal id="modal-search-courtesy-contact-2" size="xl" hide-header hide-footer scrollable
                                 @hide="resetSelection">
                            <h2>Search Contacts</h2>
                            <hr/>
                            <form ref="form" @submit.prevent="save">
                                <div v-show="'preparer'=== 'preparer'">
                                    <b-row>
                                        <b-col cols="12">
                                            <EmailSearch :original-contact="courtesyContact2" @enable="enableCC2"
                                                         v-model="courtesyContact2"
                                                         :v="$v.courtesyContact2"/>
                                        </b-col>
                                    </b-row>
                                </div>

                                <b-row style="padding-top: 10px;">
                                    <b-col>
                                        <b-button @click="close" style="margin-right:15px;">Close</b-button>
                                    </b-col>
                                </b-row>
                            </form>
                        </b-modal>
                        <div class="form-row">

                            <div class="col-xl-4 col-lg-4 col-md-4">
                                <div class="form-group">
                                    <label for="courtesyContact2-salutation">Courtesy Contact Salutation:</label>
                                    <div class="w-50">
                                        <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-salutation"
                                                      type="text" class="form-control"
                                                      v-model.trim="$v.courtesyContact2.salutation.$model"
                                                      :class="{'is-invalid': validationStatus($v.courtesyContact2.salutation)}"
                                                      aria-label="Courtesy contact salutation">
                                        </b-form-input>
                                    </div>
                                    <div v-if="!$v.courtesyContact2.salutation.required" class="invalid-feedback">
                                        Courtesy contact salutation is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.salutation.minLength" class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4">
                                <div class="form-group">
                                    <label for="courtesyContact2-prepareNamef">Courtesy Contact First Name:</label>
                                    <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareNamef"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact2.prepareNamef.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareNamef)}"
                                                  aria-label="Courtesy contact first name">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact2.prepareNamef.required" class="invalid-feedback">
                                        Courtesy contact first name is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.prepareNamef.minLength"
                                         class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4">
                                <div class="form-group">
                                    <label for="courtesyContact2-prepareNamel">Courtesy Contact Last Name:</label>
                                    <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareNamel"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact2.prepareNamel.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareNamel)}"
                                                  aria-label="Courtesy contact last name">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact2.prepareNamel.required" class="invalid-feedback">
                                        Courtesy contact last name is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.prepareNamel.minLength"
                                         class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">

                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label for="courtesyContact2-title">Courtesy Contact Title:</label>
                                    <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-title"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact2.title.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact2.title)}"
                                                  aria-label="Courtesy contact title">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact2.title.required" class="invalid-feedback">
                                        Courtesy
                                        contact title is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.title.minLength" class="invalid-feedback">Text
                                        needs to be entered
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="form-row">

                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact2-prepareEmail">Courtesy Contact Email:</label>
                                    <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareEmail"
                                                  type="email" class="form-control" max="50"
                                                  v-model.trim="$v.courtesyContact2.prepareEmail.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareEmail)}"
                                                  aria-label="Courtesy contact email">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact2.prepareEmail.required" class="invalid-feedback">
                                        Courtesy contact email is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.prepareEmail.email" class="invalid-feedback">
                                        Courtesy contact email must be a valid email address
                                    </div>
                                    <div v-if="!$v.courtesyContact2.prepareEmail.minLength"
                                         class="invalid-feedback">Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">

                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label for="courtesyContact2-prepareorgName">Courtesy Contact Organization Name:</label>
                                    <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareorgName"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact2.prepareorgName.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareorgName)}"
                                                  aria-label="Courtesy contact organization name">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact2.prepareorgName.required"
                                         class="invalid-feedback">Courtesy contact organization name is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.prepareorgName.minLength"
                                         class="invalid-feedback">Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">

                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact2-preparePhone">Courtesy Contact Phone
                                        number:</label>
                                    <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-preparePhone"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact2.preparePhone.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact2.preparePhone)}"
                                                  aria-label="Courtesy contact phone number"
                                                  v-mask="'###-###-####'">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact2.preparePhone.required" class="invalid-feedback">
                                        Courtesy contact phone number is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.preparePhone.minLength"
                                         class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact2-phoneExt">Courtesy Contact Phone Extension:</label>
                                    <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-phoneExt"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact2.phoneExt.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact2.phoneExt)}"
                                                  aria-label="Courtesy contact phone extension"
                                                  v-mask="'###########'">
                                    </b-form-input>

                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact2-prepareFax">Courtesy Contact Fax Number:</label>
                                    <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareFax"
                                                  type="text" class="form-control"
                                                  aria-label="Courtesy contact fax number"
                                                  v-model.trim="$v.courtesyContact2.prepareFax.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareFax)}"
                                                  v-mask="'###-###-####'">
                                    </b-form-input>

                                </div>
                            </div>

                        </div>

                        <div class="form-row">

                            <div class="col-xl-8 col-lg-8 col-md-8">
                                <div class="form-group">
                                    <label for="courtesyContact2-prepareAddress">Courtesy Contact Address Line 1
                                        (example: 123 Main Street North, or PO Box 153):</label>
                                    <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareAddress"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact2.prepareAddress.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareAddress)}"
                                                  aria-label="Courtesy Contact Address Line 1">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact2.prepareAddress.required"
                                         class="invalid-feedback">Courtesy contact address line 1 is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.prepareAddress.minLength"
                                         class="invalid-feedback">Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-8 col-lg-8 col-md-8">
                                <div class="form-group">
                                    <label for="courtesyContact2-streetAddress2">Courtesy Contact Address Line 2
                                        (example: Suite B):</label>
                                    <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-streetAddress2"
                                                  type="text" class="form-control"
                                                  v-model.trim="$v.courtesyContact2.streetAddress2.$model"
                                                  :class="{'is-invalid': validationStatus($v.courtesyContact2.streetAddress2)}"
                                                  aria-label="Courtesy Contact Address Line 2">
                                    </b-form-input>
                                    <div v-if="!$v.courtesyContact2.streetAddress2.required"
                                         class="invalid-feedback">Courtesy contact address line 2 is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.streetAddress2.minLength"
                                         class="invalid-feedback">Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact2-prepareCity">Courtesy Contact City:</label>
                                    <input :disabled="keepDisabledCC2" id="courtesyContact2-prepareCity"
                                           type="text" class="form-control" v-uppercase
                                           v-model.trim="$v.courtesyContact2.prepareCity.$model"
                                           v-on:change="saintToSt(1, 3)"
                                           :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareCity)}"
                                           aria-label="Courtesy contact city" />
                                    <div v-if="!$v.courtesyContact2.prepareCity.required" class="invalid-feedback">
                                        Courtesy contact city is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.prepareCity.minLength" class="invalid-feedback">
                                        Text
                                        needs to be entered
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact2-prepareCounty">Courtesy Contact County:</label>
                                    <input :disabled="keepDisabledCC2" id="courtesyContact2-prepareCounty"
                                           type="text" class="form-control" v-uppercase
                                           v-model.trim="$v.courtesyContact2.prepareCounty.$model"
                                           v-on:change="saintToSt(2, 3)"
                                           :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareCounty)}"
                                           aria-label="Courtesy contact county" />
                                    <div v-if="!$v.courtesyContact2.prepareCounty.required"
                                         class="invalid-feedback">
                                        Courtesy contact county is required
                                    </div>
                                    <div v-if="!$v.courtesyContact2.prepareCounty.minLength"
                                         class="invalid-feedback">
                                        Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="courtesyContact2-prepareState">Courtesy Contact
                                        State/Province: </label>
                                    <v-select
                                        :disabled="keepDisabledCC2"
                                        id="courtesyContact2-prepareState"
                                        v-model.trim="$v.courtesyContact2.prepareState.$model"
                                        :options="stateProvince"
                                        :reduce="text => text.value"
                                        :items="stateProvince.value"
                                        label="text"
                                        type="select"
                                        placeholder="Select a state or province"
                                        :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareState)}"
                                    ></v-select>
                                    <span v-if="!$v.courtesyContact2.prepareState.required"
                                          class="invalid-feedback">State is required</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group "
                                     v-if="!selectedCountryCan($v.courtesyContact2.prepareState.$model,3)">
                                    <label for="courtesyContact2-prepareZip5">Courtesy Contact U.S. ZIP Code or Canadian Postal Code:</label>
                                    <input :disabled="keepDisabledCC2" id="courtesyContact2-prepareZip5"
                                           type="text" v-mask="'#####'"
                                           class="form-control"
                                           v-model.trim="$v.courtesyContact2.prepareZip5.$model"
                                           :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareZip5)}"
                                           aria-label="Courtesy contact zip code"/>
                                    <div v-if="!$v.courtesyContact2.prepareZip5.minLength"
                                         class="invalid-feedback">Text needs to be entered
                                    </div>
                                </div>
                            </div>


                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group "
                                     v-if="!selectedCountryCan($v.courtesyContact2.prepareState.$model,3)">
                                    <label for="courtesyContact2-prepareZip4">Courtesy Contact U.S. ZIP Code
                                        Extension:</label>
                                    <input :disabled="isDisabledCC2(courtesyContact2.prepareZip5)"
                                           id="courtesyContact2-prepareZip4"
                                           type="text" v-mask="'####'"
                                           class="form-control"
                                           v-model.trim="$v.courtesyContact2.prepareZip4.$model"
                                           :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareZip4)}"
                                           aria-label="Courtesy contact zip code"/>
                                    <div v-if="!$v.courtesyContact2.prepareZip4.minLength"
                                         class="invalid-feedback">Text needs to be entered
                                    </div>
                                </div>
                            </div>


                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="form-group "
                                     v-if="selectedCountryCan($v.courtesyContact2.prepareState.$model,3)">
                                    <label for="courtesyContact2-canZipContact">Courtesy Contact U.S. ZIP Code or Canadian Postal Code:</label>
                                    <input :disabled="keepDisabledCC2"
                                           id="courtesyContact2-canZipContact" type="text"
                                           v-mask="'A#A #A#'" class="form-control"
                                           v-model.trim="$v.courtesyContact2.canZipContact.$model"
                                           :class="{'is-invalid': validationStatus($v.courtesyContact2.canZipContact)}"
                                           aria-label="Courtesy contact can postal code"/>
                                    <div v-if="!$v.courtesyContact2.canZipContact.minLength"
                                         class="invalid-feedback">Text needs to be entered
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import {required, minLength, email, maxLength, requiredIf} from 'vuelidate/lib/validators'
import EmailSearch from '@/components/EmailSearch'
import lambdaURL from '../lambda'



export default {

    directives: {
        uppercase: {
            componentUpdated (el) {
                el.value = el.value.toUpperCase();
            },
        }
    },

    components: {
        EmailSearch
    },

    mounted() {
        lambdaURL.getDemography(this.$route.params.id, this.$keycloak.userName, this.$keycloak.fullName).then((res) => {
            this.$data.hccisId = res.hccisId;
            this.$data.company = res.name;
            //console.log(this.$data);
        })
            .catch((err) => {
            })
        lambdaURL.proceedToContact(this.$route.params.id, this.$keycloak.userName, this.$keycloak.userEmail).then((res) => {
            Object.assign(this.$data.contact, res);
            //this.validate();
            this.$emit('mergeOriginal', this.$data);
            //console.log(this.$data.contact);
            //this.$data.showPreparer = true;
            /**this.$data.contact = res;**/
        })
            .catch((err) => {
            })
        lambdaURL.getCourtesyContacts(this.$route.params.id, this.$keycloak.userName).then((res) => {
                Object.assign(this.$data.courtesyContact, res[0]);
                Object.assign(this.$data.courtesyContact2, res[1]);
                if (res[0] != null) {
                    this.$data.showCC1 = true;
                    //console.log('cc1 not null')
                }
                if (res[1] != null) {
                    this.$data.showCC2 = true;
                    //console.log('cc2 not null')
                }
                //this.validate();
                this.$emit('mergeOriginal', this.$data);
            }
        )
            .catch((err) => {
            })
    },
    data: function () {
        return {
            hccisId: '',
            company: '',
            stateProvince: [
                {value: 'AL', text: 'AL – Alabama'},
                {value: 'AK', text: 'AK – Alaska'},
                {value: 'AS', text: 'AS – American Samoa'},
                {value: 'AZ', text: 'AZ – Arizona'},
                {value: 'AR', text: 'AR – Arkansas'},
                {value: 'CA', text: 'CA – California'},
                {value: 'CO', text: 'CO – Colorado'},
                {value: 'CT', text: 'CT – Connecticut'},
                {value: 'DE', text: 'DE – Delaware'},
                {value: 'DC', text: 'DC – District of Columbia'},
                {value: 'FM', text: 'FM – Federated States of Micronesia'},
                {value: 'FL', text: 'FL – Florida'},
                {value: 'GA', text: 'GA – Georgia'},
                {value: 'GU', text: 'GU – Guam'},
                {value: 'HI', text: 'HI – Hawaii'},
                {value: 'ID', text: 'ID – Idaho'},
                {value: 'IL', text: 'IL – Illinois'},
                {value: 'IN', text: 'IN – Indiana'},
                {value: 'IA', text: 'IA – Iowa'},
                {value: 'KS', text: 'KS – Kansas'},
                {value: 'KY', text: 'KY – Kentucky'},
                {value: 'LA', text: 'LA – Louisiana'},
                {value: 'ME', text: 'ME – Maine'},
                {value: 'MH', text: 'MH – Marshall Islands'},
                {value: 'MD', text: 'MD – Maryland'},
                {value: 'MA', text: 'MA – Massachusetts'},
                {value: 'MI', text: 'MI – Michigan'},
                {value: 'MN', text: 'MN – Minnesota'},
                {value: 'MS', text: 'MS – Mississippi'},
                {value: 'MO', text: 'MO – Missouri'},
                {value: 'MT', text: 'MT – Montana'},
                {value: 'NE', text: 'NE – Nebraska'},
                {value: 'NV', text: 'NV – Nevada'},
                {value: 'NH', text: 'NH – New Hampshire'},
                {value: 'NJ', text: 'NJ – New Jersey'},
                {value: 'NM', text: 'NM – New Mexico'},
                {value: 'NY', text: 'NY – New York'},
                {value: 'NC', text: 'NC – North Carolina'},
                {value: 'ND', text: 'ND – North Dakota'},
                {value: 'MP', text: 'MP – Northern Mariana Islands'},
                {value: 'OH', text: 'OH – Ohio'},
                {value: 'OK', text: 'OK – Oklahoma'},
                {value: 'OR', text: 'OR – Oregon'},
                {value: 'PW', text: 'PW – Palau'},
                {value: 'PA', text: 'PA – Pennsylvania'},
                {value: 'PR', text: 'PR – Puerto Rico'},
                {value: 'RI', text: 'RI – Rhode Island'},
                {value: 'SC', text: 'SC – South Carolina'},
                {value: 'SD', text: 'SD – South Dakota'},
                {value: 'TN', text: 'TN – Tennessee'},
                {value: 'TX', text: 'TX – Texas'},
                {value: 'UT', text: 'UT – Utah'},
                {value: 'VT', text: 'VT – Vermont'},
                {value: 'VI', text: 'VI – Virgin Islands'},
                {value: 'VA', text: 'VA – Virginia'},
                {value: 'WA', text: 'WA – Washington'},
                {value: 'WV', text: 'WV – West Virginia'},
                {value: 'WI', text: 'WI – Wisconsin'},
                {value: 'WY', text: 'WY – Wyoming'},
                {value: 'AB', text: 'AB – Alberta'},
                {value: 'BC', text: 'BC – British Columbia'},
                {value: 'MB', text: 'MB – Manitoba'},
                {value: 'NB', text: 'NB – New Brunswick'},
                {value: 'NF', text: 'NF – Newfoundland'},
                {value: 'NT', text: 'NT – Northwest Territories'},
                {value: 'NS', text: 'NS – Nova Scotia'},
                {value: 'NU', text: 'NU – Nunavut'},
                {value: 'ON', text: 'ON – Ontario'},
                {value: 'PE', text: 'PE – Prince Edward Island'},
                {value: 'QC', text: 'QC – Quebec'},
                {value: 'SK', text: 'SK – Saskatchewen'},
                {value: 'YT', text: 'YT – Yukon'}
            ],
            contact: {
                contactId: null,
                hccisContactId: null,
                sourceTypeId: 86,
                prepareEmail: '',
                salutation: '',
                title: '',
                prepareNamef: '',
                prepareorgName: '',
                prepareAddress: '',
                streetAddress2: '',
                prepareCity: '',
                prepareCounty: '',
                prepareState: '',
                prepareZip5: '',
                prepareZip4: '',
                canZipContact: '',
                prepareSupTitle: '',
                prepareSupPhone: '',
                company: '',
                prepareNamel: '',
                preparePhone: '',
                phoneExt: '',
                prepareFax: '',
                prepareSupNamef: '',
                prepareSupNamel: '',
                prepareSupEmail: '',
                newContact: null,
                //contactTypeId: 31
            },
            courtesyContact: {
                prepareNamef: '',
                prepareNamel: '',
                salutation: '',
                title: '',
                prepareorgName: '',
                prepareEmail: '',
                preparePhone: '',
                phoneExt: '',
                prepareFax: '',
                prepareAddress: '',
                streetAddress2: '',
                prepareCity: '',
                prepareCounty: '',
                prepareState: '',
                prepareZip5: '',
                prepareZip4: '',
                canZipContact: '',
                //contactTypeId: 32,
                sourceTypeId: 86
            },
            courtesyContact2: {
                prepareNamef: '',
                prepareNamel: '',
                salutation: '',
                title: '',
                prepareorgName: '',
                prepareEmail: '',
                preparePhone: '',
                phoneExt: '',
                prepareFax: '',
                prepareAddress: '',
                streetAddress2: '',
                prepareCity: '',
                prepareCounty: '',
                prepareState: '',
                prepareZip5: '',
                prepareZip4: '',
                canZipContact: '',
                //contactTypeId: 32,
                sourceTypeId: 86
            },
            hasError: false,
            viewNoChangesText: false,
            selectedEdit: '',
            defaultEdit: 'Please select contact action',
            keepDisabled: true,
            showCC1: false,
            showCC2: false,
            selectedEditCC1: '',
            selectedEditCC2: '',
            keepDisabledCC1: true,
            keepDisabledCC2: true,
            courtesyContactMessage: '',
            courtesyContact2Message: '',
        }
    },
    validations: {
        hccisId: {
            required
        },
        contact: {
            contactId: {
                required: false
            },
            hccisContactId: {
                required: false
            },
            sourceTypeId: {
                required: false
            },
            prepareEmail: {
                required,
                email,
                minLength: minLength(1),
                maxLength: maxLength(50)
            },
            salutation: {
                required: false
            },
            title: {
                required: false
            },
            prepareNamef: {
                required,
                minLength: minLength(1),
                maxLength: maxLength(100)
            },
            prepareorgName: {
                required: false
            },
            prepareAddress: {
                required: false
            },
            streetAddress2: {
                required: false
            },
            prepareCity: {
                required: false
            },
            prepareCounty: {
                required: false
            },
            prepareState: {
                required: false
            },
            prepareZip5: {
                required: false,
                minLength: minLength(5)
            },
            prepareZip4: {
                required: false,
                minLength: minLength(4)
            },
            canZipContact: {
                required: false,
                minLength: minLength(7)
            },
            prepareSupTitle: {
                required: false
            },
            prepareSupPhone: {
                required: false
            },
            company: {
                required: false
            },
            prepareNamel: {
                required,
                minLength: minLength(1),
                maxLength: maxLength(100)
            },
            preparePhone: {
                required: false
            },
            phoneExt: {
                required: false
            },
            prepareFax: {
                required: false
            },
            prepareSupNamef: {
                required: false
            },
            prepareSupNamel: {
                required: false
            },
            prepareSupEmail: {
                required: false
            },
            newContact: {
                required: false
            }
        },
        courtesyContact: {
            //prepareNamef: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            //prepareNamel: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareNamef: {
                required: requiredIf(function () {
                    return this.showCC1 === true
                }), minLength: minLength(1), maxLength: maxLength(50)
            },
            prepareNamel: {
                required: requiredIf(function () {
                    return this.showCC1 === true
                }), minLength: minLength(1), maxLength: maxLength(50)
            },
            salutation: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            title: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareorgName: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareEmail: {
                required: requiredIf(function () {
                    return this.showCC1 === true
                }), email, minLength: minLength(1), maxLength: maxLength(50)
            },
            preparePhone: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            phoneExt: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareFax: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareAddress: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            streetAddress2: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareCity: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareCounty: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareState: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareZip5: {required: false, minLength: minLength(5)},
            prepareZip4: {required: false, minLength: minLength(4)},
            canZipContact: {required: false, minLength: minLength(7)},
            sourceTypeId: {required: false}
        },
        courtesyContact2: {
            //prepareNamef: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            //prepareNamel: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareNamef: {
                required: requiredIf(function () {
                    return this.showCC2 === true
                }), minLength: minLength(1), maxLength: maxLength(50)
            },
            prepareNamel: {
                required: requiredIf(function () {
                    return this.showCC2 === true
                }), minLength: minLength(1), maxLength: maxLength(50)
            },
            salutation: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            title: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareorgName: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareEmail: {
                required: requiredIf(function () {
                    return this.showCC2 === true
                }), email, minLength: minLength(1), maxLength: maxLength(50)
            },
            preparePhone: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            phoneExt: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareFax: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareAddress: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            streetAddress2: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareCity: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareCounty: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareState: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
            prepareZip5: {required: false, minLength: minLength(5)},
            prepareZip4: {required: false, minLength: minLength(4)},
            canZipContact: {required: false, minLength: minLength(7)},
            sourceTypeId: {required: false}
        },
        editItem: {
            required: false
        },
        editFields: {
            required: false
        },
        form: ['contact', 'courtesyContact', 'courtesyContact2'],
    },

    methods: {

        enable: function (value) {
            this.keepDisabled = value;
        },

        enableCC1: function (value) {
            this.keepDisabledCC1 = value;
        },

        enableCC2: function (value) {
            this.keepDisabledCC2 = value;
        },

        focusFirstStatus() {
            var errorElements = document.querySelectorAll(".is-invalid");
            if (errorElements && errorElements.length > 0) {
                var elmnt = document.getElementById(errorElements[0].id);
                elmnt.scrollIntoView();
            }
        },

        validate() {
            this.$v.form.$touch();
            var isValid = !this.$v.form.$invalid
            this.$emit('on-validate', this.$data, isValid)
            this.$nextTick(() => this.focusFirstStatus())
            return isValid
        },

        toggleShowCC1() {
            this.courtesyContactMessage = ''
            this.showCC1 = !this.showCC1
            if (!this.showCC1) {
                if (!this.showCC2) {
                    this.courtesyContact =
                        {
                            prepareNamef: '',
                            prepareNamel: '',
                            title: '',
                            prepareorgName: '',
                            prepareEmail: '',
                            preparePhone: '',
                            phoneExt: '',
                            prepareFax: '',
                            prepareAddress: '',
                            streetAddress2: '',
                            prepareCity: '',
                            prepareCounty: '',
                            prepareState: '',
                            prepareZip5: '',
                            prepareZip4: '',
                            canZipContact: '',
                            //contactTypeId: 32,
                            sourceTypeId: 86
                        }
                    this.$nextTick(() => {
                        this.courtesyContactMessage = 'Removed courtesy contact 1.'
                    })
                } else {
                    this.courtesyContact = JSON.parse(JSON.stringify(this.courtesyContact2))
                    this.showCC2 = false
                    this.showCC1 = true
                    this.courtesyContact2 =
                        {
                            prepareNamef: '',
                            prepareNamel: '',
                            title: '',
                            prepareorgName: '',
                            prepareEmail: '',
                            preparePhone: '',
                            phoneExt: '',
                            prepareFax: '',
                            prepareAddress: '',
                            streetAddress2: '',
                            prepareCity: '',
                            prepareCounty: '',
                            prepareState: '',
                            prepareZip5: '',
                            prepareZip4: '',
                            canZipContact: '',
                            //contactTypeId: 32,
                            sourceTypeId: 86
                        }
                    this.$nextTick(() => {
                        this.courtesyContactMessage = 'Replaced courtesy contact 1 with courtesy contact 2.'
                    })
                }
            } else {
                this.$nextTick(() => {
                    this.courtesyContactMessage = 'Added courtesy contact 1.'
                })
            }
        },

        toggleShowCC2() {
            this.courtesyContact2Message = ''
            this.showCC2 = !this.showCC2
            if (!this.showCC2) {
                this.courtesyContact2 =
                    {
                        prepareNamef: '',
                        prepareNamel: '',
                        title: '',
                        prepareorgName: '',
                        prepareEmail: '',
                        preparePhone: '',
                        phoneExt: '',
                        prepareFax: '',
                        prepareAddress: '',
                        streetAddress2: '',
                        prepareCity: '',
                        prepareCounty: '',
                        prepareState: '',
                        prepareZip5: '',
                        prepareZip4: '',
                        canZipContact: '',
                        //contactTypeId: 32,
                        sourceTypeId: 86
                    }
                this.$nextTick(() => {
                    this.courtesyContact2Message = 'Removed courtesy contact 2.'
                })
            } else {
                this.$nextTick(() => {
                    this.courtesyContact2Message = 'Added courtesy contact 2.'
                })
            }
        },

        close() {
            this.$bvModal.hide('modal-search-contacts')
            this.$bvModal.hide('modal-search-courtesy-contact')
            this.$bvModal.hide('modal-search-courtesy-contact-2')
        },

        save() {
            this.$bvModal.hide('modal-search-contacts')

        },

        resetSelection() {
            this.selectedEdit = ''
            this.selectedEditCC1 = ''
            this.selectedEditCC2 = ''
        },

        validationStatus: function (validation) {
            return typeof validation != "undefined" ? validation.$error : false;
        },

        changeContact: function (args) {
            if (args === '1') {
                this.keepDisabled = true;
                this.validate();
                //this.$emit('proceed');
                this.viewNoChangesText = true;
                //this.$parent.refs.wizard.nextTab();
                //window.location.replace('/dropzone');
                //viewText = 'Click next to proceed.'
            }
            if (args === '2') {
                this.keepDisabled = false;
                this.viewNoChangesText = false;
            }
            if (args === '3' || args === '4') {
                this.$bvModal.show('modal-search-contacts')
                this.viewNoChangesText = false;
                //window.location.replace('/emailsearch');
            }
        },

        changeCC1: function (args) {
            if (args === '1') {
                this.keepDisabledCC1 = true;
                this.validate();
                //this.$parent.refs.wizard.nextTab();
                //window.location.replace('/dropzone');
                //viewText = 'Click next to proceed.'
            }
            if (args === '2') {
                this.keepDisabledCC1 = false;
            }
            if (args === '3' || args === '4') {
                this.$bvModal.show('modal-search-courtesy-contact')
                //window.location.replace('/emailsearch');
            }
        },

        changeCC2: function (args) {
            if (args === '1') {
                this.keepDisabledCC2 = true;
                this.validate();
                //this.$parent.refs.wizard.nextTab();
                //window.location.replace('/dropzone');
                //viewText = 'Click next to proceed.'
            }
            if (args === '2') {
                this.keepDisabledCC2 = false;
            }
            if (args === '3' || args === '4') {
                this.$bvModal.show('modal-search-courtesy-contact-2')
                //window.location.replace('/emailsearch');
            }
        },

        addContact() {
            window.location.replace('/courtesyContact');
        },

        finishNow() {
            this.validate();
            this.$emit('skipToFinish');
        },

        selectedCountryCan: function (stateOrProvince, type) {
            let returnThisAnswer = false;
            if (stateOrProvince === 'AB' || stateOrProvince === 'BC' || stateOrProvince === 'MB'
                || stateOrProvince === 'NB' || stateOrProvince === 'NF' || stateOrProvince === 'NS' || stateOrProvince === 'NU'
                || stateOrProvince === 'NT' || stateOrProvince === 'ON' || stateOrProvince === 'PE' || stateOrProvince === 'QC'
                || stateOrProvince === 'SK' || stateOrProvince === 'YU') {
                returnThisAnswer = true;
            }
            if (type === 1) { //preparer
                if (returnThisAnswer === true) {
                    this.$data.contact.prepareZip5 = '';
                    this.$data.contact.prepareZip4 = '';
                } else {
                    this.$data.contact.canZipContact = '';
                }
            }
            if (type === 2) { //courtesy 1
                if (returnThisAnswer === true) {
                    this.$data.courtesyContact.prepareZip5 = '';
                    this.$data.courtesyContact.prepareZip4 = '';
                } else {
                    this.$data.courtesyContact.canZipContact = '';
                }
            }
            if (type === 3) { //courtesy 2
                if (returnThisAnswer === true) {
                    this.$data.courtesyContact2.prepareZip5 = '';
                    this.$data.courtesyContact2.prepareZip4 = '';
                } else {
                    this.$data.courtesyContact2.canZipContact = '';
                }
            }
            return returnThisAnswer;
        },
        isDisabledC: function (zipValue) {
            if (typeof zipValue === 'undefined' || zipValue === null) {
                zipValue = 'a'; // method only looks for the length of 5, so one char is okay
            }
            let trueFalseFormula = zipValue.length;
            let disabledDefault = true;
            if (trueFalseFormula !== 5) {
                this.$data.contact.prepareZip4 = '';
                if (this.keepDisabled) {
                    disabledDefault = true;
                }
            }
            if (trueFalseFormula === 5 && !this.keepDisabled) {
                disabledDefault = false;
            }
            //alert("zip value? " + trueFalseFormula + " keepDisabled: " + this.keepDisabled + "isDisabled: " + disabledDefault);
            return disabledDefault;

        },
        isDisabledCC1: function (zipValue) {
            if (typeof zipValue === 'undefined' || zipValue === null) {
                zipValue = 'a'; // method only looks for the length of 5, so one char is okay
            }
            let trueFalseFormula = zipValue.length;
            let disabledDefault = true;
            if (trueFalseFormula !== 5) {
                this.$data.courtesyContact.prepareZip4 = '';
                if (this.keepDisabledCC1) {
                    disabledDefault = true;
                }
            }
            if (trueFalseFormula === 5 && !this.keepDisabledCC1) {
                disabledDefault = false;
            }
            return disabledDefault;

        },
        isDisabledCC2: function (zipValue) {
            if (typeof zipValue === 'undefined' || zipValue === null) {
                zipValue = 'a'; // method only looks for the length of 5, so one char is okay
            }
            let trueFalseFormula = zipValue.length;
            let disabledDefault = true;
            if (trueFalseFormula !== 5) {
                this.$data.courtesyContact2.prepareZip4 = '';
                if (this.keepDisabledCC2) {
                    disabledDefault = true;
                }
            }
            if (trueFalseFormula === 5 && !this.keepDisabledCC2) {
                disabledDefault = false;
            }
            return disabledDefault;

        },
        phoneCheck: function (phoneNum) {
            let phoneErrorMessage = false;
            let phone1 =  phoneNum.toString().substring(0,1);
            let phone2 = phoneNum.toString().substring(4);
            phone2 = phone2.toString().substring(0,1);
            if (phone1 != '' && (phone1 === '0' || phone1 === '1')) {
                phoneErrorMessage = true;
            } else if (phone2 != '' && (phone2 === '0' || phone2 === '1')) {
                phoneErrorMessage = true;
            }
            return phoneErrorMessage;
        },
        saintToSt(locationType, contactType) {
            if (locationType === 1) {
                if (contactType === 1) {
                    if (this.$data.contact.prepareCity.substring(0,5).toUpperCase()=='SAINT') {
                        this.$data.contact.prepareCity = this.$data.contact.prepareCity.replace(/SAINT/i, 'ST.');
                    } else if (this.$data.contact.prepareCity.substring(0,3).toUpperCase()=='ST ') {
                        this.$data.contact.prepareCity = this.$data.contact.prepareCity.replace(/ST/i, 'ST.');
                    }
                }
                if (contactType === 2) {
                    if (this.$data.courtesyContact.prepareCity.substring(0,5).toUpperCase()=='SAINT') {
                        this.$data.courtesyContact.prepareCity = this.$data.courtesyContact.prepareCity.replace(/SAINT/i, 'ST.');
                    } else if (this.$data.courtesyContact.prepareCity.substring(0,3).toUpperCase()=='ST ') {
                        this.$data.courtesyContact.prepareCity = this.$data.courtesyContact.prepareCity.replace(/ST/i, 'ST.');
                    }
                }
                if (contactType === 3) {
                    if (this.$data.courtesyContact2.prepareCity.substring(0,5).toUpperCase()=='SAINT') {
                        this.$data.courtesyContact2.prepareCity = this.$data.courtesyContact2.prepareCity.replace(/SAINT/i, 'ST.');
                    } else if (this.$data.courtesyContact2.prepareCity.substring(0,3).toUpperCase()=='ST ') {
                        this.$data.courtesyContact2.prepareCity = this.$data.courtesyContact2.prepareCity.replace(/ST/i, 'ST.');
                    }
                }
            }
            if (locationType === 2) {
                if (contactType === 1) {
                    if (this.$data.contact.prepareCounty.substring(0,5).toUpperCase()=='SAINT') {
                        this.$data.contact.prepareCounty = this.$data.contact.prepareCounty.replace(/SAINT/i, 'ST.');
                    } else if (this.$data.contact.prepareCounty.substring(0,3).toUpperCase()=='ST ') {
                        this.$data.contact.prepareCounty = this.$data.contact.prepareCounty.replace(/ST/i, 'ST.');
                    }
                }
                if (contactType === 2) {
                    if (this.$data.courtesyContact.prepareCounty.substring(0,5).toUpperCase()=='SAINT') {
                        this.$data.courtesyContact.prepareCounty = this.$data.courtesyContact.prepareCounty.replace(/SAINT/i, 'ST.');
                    } else if (this.$data.courtesyContact.prepareCounty.substring(0,3).toUpperCase()=='ST ') {
                        this.$data.courtesyContact.prepareCounty = this.$data.courtesyContact.prepareCounty.replace(/ST/i, 'ST.');
                    }
                }
                if (contactType === 3) {
                    if (this.$data.courtesyContact2.prepareCounty.substring(0,5).toUpperCase()=='SAINT') {
                        this.$data.courtesyContact2.prepareCounty = this.$data.courtesyContact2.prepareCounty.replace(/SAINT/i, 'ST.');
                    } else if (this.$data.courtesyContact2.prepareCounty.substring(0,3).toUpperCase()=='ST ') {
                        this.$data.courtesyContact2.prepareCounty = this.$data.courtesyContact2.prepareCounty.replace(/ST/i, 'ST.');
                    }
                }
            }
        }
    }
}
</script>
<style>
.vs--disabled .vs__dropdown-toggle, .vs--disabled .vs__clear, .vs--disabled .vs__search, .vs--disabled .vs__selected, .vs--disabled .vs__open-indicator {
    background-color: #e9ecef;
}
.col-lg-2-calyear {
  margin-left: auto;
}
</style>